import React, { Component } from 'react';
import Dico from '../../helpers/Dico'
import CalculatorInfoBenefit from './CalculatorInfoBenefit';
import CustomerCriteria from './CustomerCriteria';
import DurationSelector from './DurationSelector';
import MileagesSelector from './MileagesSelector';
import DepositSelector from './DepositSelector';
import IconRender from '../std/IconRender';
import HelperCriteriaCalculator from '../../helpers/HelperCriteriaCalculator';
import HelperGenerics from '../../helpers/HelperGenerics';

class CalculatorCriteriaSvcLevels extends Component {

    maxNumCols = 3;
    maxNumColsSm = 2;

    handleOfferChange = (productKey) => {
        this.props.onChangeProduct(productKey);
    };

    handleCloseBenefit = () => {
        this.props.onCloseBenefit();
    }
    handleCloseServiceInformation = () => {
        this.props.onCloseServiceInformation();
    }

    handleServiceChange = (event, pckCode, svcCode) => {
        const checked = event.target.checked === true;
        const svcMap = this.props.svcMap;
        this.applyServiceSelected(svcMap, checked, pckCode, svcCode);
        this.props.onChangeService(svcMap, this.props.settings);
    }

    applyServiceSelected(svcMap, checked, pckCode, svcCode) {
        for (const svcMapKey in svcMap) {
            if (HelperCriteriaCalculator.getFlatSvcKey(svcCode, pckCode) === svcMapKey) {
                svcMap[svcMapKey].selected = checked;
            } else if (pckCode === svcMapKey) {
                this.applyServiceSelectedInPackage(svcMap, checked, svcMapKey, svcCode, pckCode);
            }
        }
    }

    applyServiceSelectedInPackage(svcMap, checked, svcMapKey, svcCode, pckCode) {
        for (const svcMapSubKey in svcMap[svcMapKey]) {
            if (HelperCriteriaCalculator.getFlatSvcKey(svcCode, pckCode) === svcMapSubKey) {
                for (const svcMapSubKey in svcMap[svcMapKey]) {
                    svcMap[svcMapKey][svcMapSubKey].selected = checked;
                }
            }
        }
        svcMap[svcMapKey].selected = checked;
    }

    handleServiceLevelChanged = (levelCode) => {
        const svcMap = this.props.svcMap;
        this.props.svcLevelFiltered.levels.forEach(levelElt => {
            if (levelElt.levelCode !== levelCode && levelElt.services) {
                levelElt.services.forEach(svcElt => {
                    this.applyServiceSelected(svcMap, false, svcElt.packageCode, svcElt.serviceCode);
                });
            }
        });
        this.props.svcLevelFiltered.levels.forEach(levelElt => {
            if (levelElt.levelCode === levelCode && levelElt.services) {
                levelElt.services.forEach(svcElt => {
                    this.applyServiceSelected(svcMap, true, svcElt.packageCode, svcElt.serviceCode);
                });
            }
        });
        this.props.onChangeService(svcMap, this.props.settings);
    }

    getMessage(i18nKey) { return Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, i18nKey) }

    render() {
        const hasCriteria = this.props.responseCriteria && !this.props.responseCriteria.hasError;
        const customerCriteria = this.props.responseCriteria ? this.props.responseCriteria.customerCriteria : null;

        return (
            <div className="row p-1 m-1">
                <div className="row shadow-sm rounded m-auto">
                    <React.Fragment>
                        {this.renderProductsTab()}
                        <div className="row shadow-sm rounded m-auto mb-3">
                            {this.props.isCalculationResult
                                && this.props.calculationResponse.result.globalText
                                && this.props.calculationResponse.result.globalText.detailInformationLink
                                && HelperGenerics.renderLink(this.props.calculationResponse.result.globalText.detailInformationLink.href, null,
                                    this.props.calculationResponse.result.globalText.detailInformationLink.text, 'btn btn-link text-start')
                            }
                        </div>
                        {hasCriteria && <React.Fragment>
                            {this.renderServiceLevels()}
                            {customerCriteria != null &&
                                <div className="row m-auto">
                                    <h5 className="text-secondary">{this.getMessage('calculatorPage.criteria.customer')}</h5>
                                    <CustomerCriteria
                                        context={this.props.context}
                                        availableValues={customerCriteria}
                                        onChange={this.handleCustomerChange}
                                    />
                                </div>
                            }
                            <div className="row pe-0 row-cols-1 row-cols-lg-3 row-cols-sm-2">
                                <div className="col">
                                    <DepositSelector
                                        settings={this.props.settings}
                                        context={this.props.context}
                                        deposits={this.props.responseCriteria.deposits}
                                        parameters={this.props.parameters}
                                        contextCriteria={this.props.contextCriteria}
                                        onChange={this.props.onChangeDeposit}
                                    />
                                </div>
                                <div className="col">
                                    <DurationSelector
                                        settings={this.props.settings}
                                        context={this.props.context}
                                        parameters={this.props.parameters}
                                        contextCriteria={this.props.contextCriteria}
                                        onChange={this.props.onChangeDuration}
                                    />
                                </div>
                                <div className="col">
                                    <MileagesSelector
                                        settings={this.props.settings}
                                        context={this.props.context}
                                        mileages={this.props.responseCriteria.mileages}
                                        parameters={this.props.parameters}
                                        contextCriteria={this.props.contextCriteria}
                                        onChange={this.props.onChangeMileage}
                                    />
                                </div>
                            </div>
                            {this.renderServices()}
                        </React.Fragment>}
                    </React.Fragment>
                </div>
            </div>
        );
    }

    renderProductsTab() {
        const parameters = this.props.parameters ? this.props.parameters : {};
        const productKey = parameters.productKey != null ? parameters.productKey :
            this.props.responseOffers && this.props.responseOffers.selectedProductId && this.props.responseOffers.selectedProductId.productKey;

        return (
            <React.Fragment>
                {this.props.responseOffers &&
                    this.props.responseOffers.hasOffers && this.props.responseOffers.selectedProductId != null &&
                    <ul className="nav nav-pills nav-fill">
                        {this.props.responseOffers.offers.map((product, index) => {
                            const classActive = product.financialProductId.productKey === productKey ? 'active' : '';
                            return (
                                <li className="nav-item" key={index}>
                                    <button className={`nav-link ${classActive}`}
                                        style={{ borderColor: 'var(--bs-primary)', borderWidth: '1px', borderStyle: 'solid' }}
                                        onClick={() => { this.handleOfferChange(product.financialProductId.productKey) }}>
                                        {product.label}
                                        {product.description && <p>{product.description}</p>}
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                }
            </React.Fragment>
        );
    }

    renderServiceLevels() {
        let numCols = this.props.svcLevelFiltered && this.props.svcLevelFiltered.levels && this.props.svcLevelFiltered && this.props.svcLevelFiltered.levels.length;
        if (numCols > this.maxNumCols) {
            numCols = this.maxNumCols;
        }
        let numColsSm = numCols;
        if (numColsSm > this.maxNumColsSm) {
            numColsSm = this.maxNumColsSm;
        }
        return (
            <React.Fragment>
                {this.props.svcLevelFiltered && this.props.svcLevelFiltered.levels
                    && <React.Fragment>
                        <div className={`row m-auto mb-3 row-cols-lg-${numCols} row-cols-sm-${numColsSm} row-cols-1`}>
                            {this.props.svcLevelFiltered.levels.map((level, index) => {
                                const borderColored = level.selected ? "border-primary" : "";
                                return (
                                    <div className={`form-check border col pt-2 ${borderColored}`} key={index}>
                                        <input className="form-check-input" type="radio"
                                            checked={level.selected}
                                            readOnly={!level.selectable}
                                            onChange={() => { this.handleServiceLevelChanged(level.levelCode) }}
                                            name="calculatorLevels" id={`calculatorLevels_${level.levelCode}`}></input>
                                        <h5>
                                            {level.highlight != null
                                                && <span className='badge rounded-pill text-bg-secondary float-end'>{level.highlight}</span>
                                            }
                                            <label className="form-check-label" htmlFor={`calculatorLevels_${level.levelCode}`}>{level.label}</label>
                                            {level.isConfirmationRequired != null && level.isConfirmationRequired === true
                                                && <span className='badge rounded-pill text-bg-secondary'>
                                                    {this.getMessage('calculatorPage.levels.confirmationRequired')}
                                                </span>
                                            }
                                        </h5>
                                        {level.description && <p>{level.description}</p>}
                                        {level.benefits && <ul className="list-unstyled">
                                            {level.benefits.map((benefit, index1) => {
                                                return (<li key={index1}>
                                                    <IconRender name="check" />{benefit.label}
                                                    {benefit.informations &&
                                                        <button className='btn btn-link'
                                                            onClick={() => { this.props.onSelectBenefit(benefit) }}>
                                                            <IconRender name="info-circle-fill" />
                                                        </button>
                                                    }
                                                    {benefit.isFree != null && benefit.isFree === true
                                                        && <span className='badge rounded-pill text-bg-secondary'>
                                                            {this.getMessage('calculatorPage.levels.isFree')}
                                                        </span>
                                                    }
                                                </li>)
                                            })}
                                        </ul>}
                                    </div>);
                            })}
                        </div>
                        <CalculatorInfoBenefit benefit={this.props.benefit} handleCloseBenefit={this.handleCloseBenefit} />
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }

    renderServices() {
        return (<React.Fragment>
            {this.props.svcLevelFiltered && this.props.svcLevelFiltered.services
                && <div className="row shadow-sm rounded m-auto mb-3">
                    <ul className='list-group'>
                        {this.props.svcLevelFiltered.services.map((service, index) => {
                            const svcPrefixLabel = service.needDescription ? `${service.needDescription} - ` : '';
                            return (<li className="list-group-item" key={index}>
                                <input className="form-check-input" type="checkbox"
                                    checked={service.selected} onChange={(event) => { this.handleServiceChange(event, service.packageCode, service.serviceCode) }}
                                    id={`servicePresentationChecked_${service.svcFlatKey}`} />
                                <label className="form-check-label" htmlFor={`servicePresentationChecked_${service.svcFlatKey}`}>
                                    {` ${svcPrefixLabel}${service.label}`}
                                </label>
                                {service.informations &&
                                    <button className='btn btn-link' onClick={() => { this.props.onSelectServiceInformation(service) }}>
                                        <IconRender name="info-circle-fill" />
                                    </button>
                                }
                                {service.asterisk && <p className='fst-italic text-muted'>{service.asterisk.label} ({index + 1})</p>}
                            </li>);
                        })}
                    </ul>
                    {this.props.svcLevelFiltered.services.map((service, index) => {
                        return (
                            <React.Fragment key={index}>
                                {service.asterisk && <p className='fst-italic text-muted' >({index + 1} {service.asterisk.description})</p>}
                            </React.Fragment>
                        );
                    })}
                    <CalculatorInfoBenefit benefit={this.props.serviceInformation}
                        handleCloseBenefit={this.handleCloseServiceInformation} />
                </div>
            }
        </React.Fragment>);
    }
}
export default (CalculatorCriteriaSvcLevels)
